import React, { useState, useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

//img
import DropDownArrow from "../../static/img/map_img/DropDownArrow.svg";

//contexts
import { MainContext } from "../../contexts/MainContext";

//styles
import "./Header.scss";
import "./Adaptations.scss";

import EllingtonLogo from "../../static/img/header_img/ellington_logo.svg";
import html2canvas from "html2canvas";

import SearchComponent from "../search/SearchComponent";

export default function Header() {
    const comRef = useRef(null);
    const proRef = useRef(null);

    const {
        selectComActive,
        setSelectComActive,
        selectProActive,
        setSelectProActive,
        setSelectActive,
        communitiesMarkers,
        setCommunitiesMarkers,
        propertiesMarkers,
        setPropertiesMarkers,
        allCommunities,
        allProperties,
        allGroups,
        pages,
        loading,
        setModal
    } = useContext(MainContext);

    const [comMobileDropDown, setComMobileDropDown] = useState(null);
    const [proMobileDropDown, setProMobileDropDown] = useState(null);

    const isHoverSupported = () => {
        return (
            typeof window !== "undefined" &&
            window.matchMedia &&
            window.matchMedia("(hover: hover) and (pointer: fine)").matches
        );
    };

    // Function to check if a community exists for a property
    const checkCommunityExists = (property) => {
        if (!property || !property.path) return false;

        // For a path like "/dubai/al-jaddaf/art-bay", we need to check if "/dubai/al-jaddaf" exists
        const pathParts = property.path.split('/');

        // Need at least 3 parts: ["", "dubai", "al-jaddaf", "art-bay"]
        if (pathParts.length < 4) return false;

        // Construct the community path: /dubai/al-jaddaf
        const communityPath = `/${pathParts[1]}/${pathParts[2]}`;

        // Find the community
        const community = allCommunities.find(community =>
            community.path === communityPath
        );

        // Check if community exists AND has a valid bird property
        return community && community.bird;
    };

    const groupProperties = allGroups
        .map((element) => {
            // Handle case where modal_map_coords_pin might not exist
            if (!element.modal_map_coords_pin || !Array.isArray(element.modal_map_coords_pin)) {
                return [];
            }
            return element.modal_map_coords_pin.filter((property) => property && property.name);
        })
        .flat();
    
    // Filter out disabled properties
    const allProperty = [
        ...allProperties.filter(property => property.enabled === undefined || property.enabled === true),
        ...groupProperties.filter(property => property.enabled === undefined || property.enabled === true),
    ];

    const mobileComDropDownToogle = (index) => {
        setComMobileDropDown((prev) => (prev === index ? null : index));
    };
    const mobileProDropDownToogle = (index) => {
        setProMobileDropDown((prev) => (prev === index ? null : index));
    };

    const comMarkersToogle = () => {
        setCommunitiesMarkers(true);
        setPropertiesMarkers(false);
        setProMobileDropDown(null);
    };

    const proMarkersToogle = () => {
        setCommunitiesMarkers(false);
        setPropertiesMarkers(true);
        setComMobileDropDown(null);
    };

    const handleComMouseEnter = () => {
        if (isHoverSupported()) {
            setSelectComActive(true);
            setSelectProActive(false);
        }
    };

    const handleComMouseLeave = () => {
        if (isHoverSupported()) {
            setSelectComActive(false);
        }
    };

    const handleProMouseEnter = () => {
        if (isHoverSupported()) {
            setSelectProActive(true);
            setSelectComActive(false);
        }
    };

    const handleProMouseLeave = () => {
        if (isHoverSupported()) {
            setSelectProActive(false);
        }
    };

    const handleComClick = (e) => {
        if (!isHoverSupported()) {
            // On touch/mobile: toggle dropdown menu
            if (selectComActive) {
                setSelectComActive(false);
                setComMobileDropDown(null);
            } else {
                setSelectComActive(true);
                setSelectProActive(false);
                setProMobileDropDown(null);
                setCommunitiesMarkers(true);
                setPropertiesMarkers(false);
                setModal(false);
            }
        } else {
            // Desktop click switches markers
            comMarkersToogle();
            setModal(false);
        }
    };

    const handleProClick = (e) => {
        if (!isHoverSupported()) {
            // On touch/mobile: toggle dropdown menu
            if (selectProActive) {
                setSelectProActive(false);
                setProMobileDropDown(null);
            } else {
                setSelectProActive(true);
                setSelectComActive(false);
                setComMobileDropDown(null);
                setCommunitiesMarkers(false);
                setPropertiesMarkers(true);
                setModal(false);
            }
        } else {
            // Desktop click switches markers
            proMarkersToogle();
            setModal(false);
        }
    };

    const takeScreenshot = () => {
        html2canvas(document.body).then((canvas) => {
            const link = document.createElement("a");
            link.href = canvas.toDataURL("image/png");
            link.download = "screenshot.png";
            link.click();
        });
    };

    useEffect(() => {
        const handleOutsideInteraction = (event) => {
            const isClickInsideCom =
                comRef.current && comRef.current.contains(event.target);
            const isClickInsidePro =
                proRef.current && proRef.current.contains(event.target);

            if (!isClickInsideCom && !isClickInsidePro) {
                setSelectComActive(false);
                setSelectProActive(false);
                setComMobileDropDown(null);
                setProMobileDropDown(null);
            }
        };

        document.addEventListener("mousedown", handleOutsideInteraction);
        document.addEventListener("touchstart", handleOutsideInteraction, {
            passive: true,
        });

        return () => {
            document.removeEventListener(
                "mousedown",
                handleOutsideInteraction
            );
            document.removeEventListener(
                "touchstart",
                handleOutsideInteraction
            );
        };
    }, [setSelectComActive, setSelectProActive]);

    return (
        <>
            <header className="header">
                <Link
                    to={"/"}
                    onClick={() => {
                        setSelectComActive(false);
                        setSelectProActive(false);
                        setSelectActive(false);
                        setModal(false);
                    }}
                    className="header-logo"
                >
                    <img
                        className="logo"
                        src={EllingtonLogo}
                        alt="ellington-image"
                    />
                </Link>
                <div className="span-con">
                    <div
                        className="span-select"
                        style={{ textAlign: "right" }}
                        ref={comRef}
                        onMouseEnter={handleComMouseEnter}
                        onMouseLeave={handleComMouseLeave}
                        onClick={handleComClick}
                    >
                        <span
                            className="span"
                            style={{
                                fontWeight: communitiesMarkers ? "600" : "500",
                            }}
                        >
                            our communities
                        </span>
                        <ul
                            className={`header-select-bottom left${
                                selectComActive ? " activeCom" : ""
                            }`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="mobile">
                                <SearchComponent />
                            </div>
                            {pages.map((city, cityIndex) => (
                                <React.Fragment key={`city-${cityIndex}`}>
                                    <div
                                        className="column"
                                        key={`column-${cityIndex}`}
                                    >
                                        <div className="city-con">
                                            <span className="city-name">
                                                {city.name}
                                            </span>
                                            <Link
                                                onClick={() => {
                                                    comMarkersToogle();
                                                    setSelectComActive(false);
                                                    setModal(false);
                                                }}
                                                to={city.path}
                                            >
                                                view all
                                            </Link>
                                        </div>
                                        {allCommunities
                                            .filter((com) =>
                                                city.path.includes(
                                                    com.path?.split("/")[1]
                                                )
                                            )
                                            .map((community, commIndex) => (
                                                <Link
                                                    to={community.path || "#"}
                                                    key={`community-${cityIndex}-${commIndex}`}
                                                    onClick={(e) => {
                                                        if (community.bird === null) {
                                                            e.preventDefault();
                                                        } else {
                                                            setSelectComActive(false);
                                                            setModal(false);
                                                        }
                                                    }}
                                                >
                                                    <li>{community.name}</li>
                                                </Link>
                                            ))}
                                    </div>
                                    <div
                                        className="column-mobile"
                                        key={`column-mobile-${cityIndex}`}
                                    >
                                        <div
                                            className="city-con"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                mobileComDropDownToogle(
                                                    cityIndex
                                                );
                                            }}
                                        >
                                            <span className="city-name">
                                                {city.name}
                                            </span>
                                            <img
                                                src={DropDownArrow}
                                                alt={
                                                    comMobileDropDown ===
                                                    cityIndex
                                                        ? "active"
                                                        : "not active"
                                                }
                                                className={`dropdown-arrow ${
                                                    comMobileDropDown ===
                                                    cityIndex
                                                        ? "active"
                                                        : ""
                                                }`}
                                            />
                                        </div>
                                        {comMobileDropDown === cityIndex && (
                                            <>
                                                <Link
                                                    onClick={() => {
                                                        comMarkersToogle();
                                                        setSelectComActive(false);
                                                        setComMobileDropDown(null);
                                                        setModal(false);
                                                    }}
                                                    to={city.path}
                                                    style={{
                                                        textDecoration:
                                                            "underline",
                                                    }}
                                                >
                                                    view all
                                                </Link>
                                                {allCommunities
                                                    .filter((com) =>
                                                        city.path.includes(
                                                            com.path?.split(
                                                                "/"
                                                            )[1]
                                                        )
                                                    )
                                                    .map(
                                                        (
                                                            community,
                                                            commIndex
                                                        ) => (
                                                            <Link
                                                                to={community.path || "#"}
                                                                key={`community-mobile-${cityIndex}-${commIndex}`}
                                                                onClick={(e) => {
                                                                    if (community.bird === null) {
                                                                        e.preventDefault();
                                                                    } else {
                                                                        setSelectComActive(false);
                                                                        setComMobileDropDown(null);
                                                                        setModal(false);
                                                                    }
                                                                }}
                                                            >
                                                                <li>
                                                                    {community.name}
                                                                </li>
                                                            </Link>
                                                        )
                                                    )}
                                            </>
                                        )}
                                    </div>
                                </React.Fragment>
                            ))}
                        </ul>
                    </div>
                    <div className="separator"/>
                    <div
                        className="span-select"
                        style={{ textAlign: "left" }}
                        ref={proRef}
                        onMouseEnter={handleProMouseEnter}
                        onMouseLeave={handleProMouseLeave}
                        onClick={handleProClick}
                    >
                        <span
                            className="span"
                            style={{
                                fontWeight: propertiesMarkers ? "600" : "500",
                            }}
                        >
                            our properties
                        </span>
                        <ul
                            className={`header-select-bottom right${
                                selectProActive ? " activePro" : ""
                            }`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="mobile">
                                <SearchComponent />
                            </div>
                            {pages.map((city, cityIndex) => (
                                <React.Fragment key={`city-${cityIndex}`}>
                                    <div
                                        className="column"
                                        key={`column-${cityIndex}`}
                                    >
                                        <div className="city-con">
                                            <span className="city-name">
                                                {city.name}
                                            </span>
                                            <Link
                                                onClick={() => {
                                                    proMarkersToogle();
                                                    setSelectProActive(false);
                                                    setModal(false);
                                                }}
                                                to={city.path}
                                            >
                                                view all
                                            </Link>
                                        </div>
                                        {allProperty
                                            .filter((com) =>
                                                city.path.includes(
                                                    com.path?.split("/")[1]
                                                )
                                            )
                                            .map((property, propIndex) => (
                                                <Link
                                                    to={property.path || "#"}
                                                    key={`community-${cityIndex}-${propIndex}`}
                                                    onClick={(e) => {
                                                        if (!checkCommunityExists(property)) {
                                                            e.preventDefault();
                                                        } else {
                                                            setSelectProActive(false);
                                                            setModal(false);
                                                        }
                                                    }}
                                                    style={{
                                                        cursor: checkCommunityExists(property) ? 'pointer' : 'not-allowed'
                                                    }}
                                                >
                                                    <li>{property.name}</li>
                                                </Link>
                                            ))}
                                    </div>
                                    <div
                                        className="column-mobile"
                                        key={`column-mobile-${cityIndex}`}
                                    >
                                        <div
                                            className="city-con"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                mobileProDropDownToogle(
                                                    cityIndex
                                                );
                                            }}
                                        >
                                            <span className="city-name">
                                                {city.name}
                                            </span>
                                            <img
                                                src={DropDownArrow}
                                                alt={
                                                    proMobileDropDown ===
                                                    cityIndex
                                                        ? "active"
                                                        : "not active"
                                                }
                                                className={`dropdown-arrow ${
                                                    proMobileDropDown ===
                                                    cityIndex
                                                        ? "active"
                                                        : ""
                                                }`}
                                            />
                                        </div>
                                        {proMobileDropDown === cityIndex && (
                                            <>
                                                <Link
                                                    onClick={() => {
                                                        proMarkersToogle();
                                                        setSelectProActive(false);
                                                        setProMobileDropDown(null);
                                                        setModal(false);
                                                    }}
                                                    to={city.path}
                                                    style={{
                                                        textDecoration:
                                                            "underline",
                                                    }}
                                                >
                                                    view all
                                                </Link>
                                                {allProperty
                                                    .filter((com) =>
                                                        city.path.includes(
                                                            com.path?.split(
                                                                "/"
                                                            )[1]
                                                        )
                                                    )
                                                    .map(
                                                        (
                                                            property,
                                                            propIndex
                                                        ) => (
                                                            <Link
                                                                to={
                                                                    property.path ||
                                                                    "#"
                                                                }
                                                                key={`community-mobile-${cityIndex}-${propIndex}`}
                                                                onClick={(e) => {
                                                                    if (!checkCommunityExists(property)) {
                                                                        e.preventDefault();
                                                                    } else {
                                                                        setSelectProActive(false);
                                                                        setProMobileDropDown(null);
                                                                        setModal(false);
                                                                    }
                                                                }}
                                                                style={{
                                                                    cursor: checkCommunityExists(property) ? 'pointer' : 'not-allowed'
                                                                }}
                                                            >
                                                                <li>
                                                                    {
                                                                        property.name
                                                                    }
                                                                </li>
                                                            </Link>
                                                        )
                                                    )}
                                            </>
                                        )}
                                    </div>
                                </React.Fragment>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="con-search">
                    <button
                        onClick={takeScreenshot}
                        className="screenShot-btn"
                    ></button>
                    <SearchComponent />
                </div>
            </header>
        </>
    );
}
